module.exports = __webpack_public_path__ + "f6915c66a79e08e11c389a8a8aa71eac.fbx";